import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import styled from "styled-components";
export var DropdownOptionWrapper = styled.div.withConfig({
  displayName: "styles__DropdownOptionWrapper"
})(["cursor:pointer;display:flex;font-size:12px;flex-direction:row;align-items:center;width:100%;height:40px;background-color:", ";outline:0;border:0;padding:0px 10px;&:hover{background-color:", ";}"], function (props) {
  return props.selected ? Core.surface.subdued : "transparent";
}, Core.surface.subdued);
export var OptionName = styled(Typography).attrs({
  truncate: true
}).withConfig({
  displayName: "styles__OptionName"
})(["width:120px;flex:none;"]);
export var ActionModalContent = styled(Column).withConfig({
  displayName: "styles__ActionModalContent"
})(["padding:", ";", "{padding:", ";}", "{padding:", ";}"], getSpacing("3x"), responsiveMediaQueries.tabletAndAbove, getSpacing("5x"), responsiveMediaQueries.desktopAndAbove, getSpacing("7x"));